import { createAction } from "@reduxjs/toolkit";
import { useAppDispatch } from "app/hooks";
import Cookies from "js-cookie";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { logout } from "services/auth-service";

export default function useLogout() {
    const dispatch = useAppDispatch()
    const logoutAction = createAction("logout")
    const navigate = useNavigate();
    const token = localStorage.getItem("token") ?? "";
    return useMutation({
        mutationFn: () => logout(token),
        onSuccess: (res) => {
            localStorage.clear()
            Cookies.remove('token');
            dispatch(logoutAction())
            navigate("/auth/login");
        }
    })
}   